import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastService } from 'angular-toastify';
import { finalize } from 'rxjs/operators';
import { ApiProviderParkingService } from '../../../../../core/services/api/provider-parking/api-provider-parking.service';
import { ApiTableService } from '../../../../../core/services/api-table.service';
import { ProviderParking } from '../../../../../core/models/provider-parking/provider-parking.model';
import { optionResponse } from '../../../../../core/models/form.model';
import { ApiFormService } from '../../../../../core/services/api-form.service';
import { Providers } from '../../../../../core/models/information.model';

@Component({
  selector: 'app-modal-provider-parking',
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-provider-parking.component.html',
  styleUrl: './modal-provider-parking.component.css'
})
export class ModalProviderParkingComponent {
  @Input() provider: ProviderParking | null = null;
  @Output() close = new EventEmitter<boolean>();
  @Output() saveSuccess = new EventEmitter<void>();

  isLoading: boolean = false;
  isEditMode: boolean = false;

  // Dropdown States
  openDropdown: string | null = null;

  // Data Lists
  formData: ProviderParking = this.getInitialFormData();
  parkingSiteList: optionResponse | null = null;
  providersList: Providers[] = [];

  // Image Upload State
  image1: string | ArrayBuffer | null = null;
  image2: string | ArrayBuffer | null = null;

  constructor(
    private apiProviderParkingService: ApiProviderParkingService,
    private apiTableService: ApiTableService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    this.getParkingSiteList();
    if (this.provider) {
      this.isEditMode = true;
      this.formData = { ...this.provider };
    } else {
      this.isEditMode = false;
      this.formData = this.getInitialFormData();
    }
  }

  private getInitialFormData(): ProviderParking {
    return {
      id: 0,
      name: '',
      address: '',
      phoneNumber: '',
      taxId: '',
      branch: '',
      vat: 0,
      shortName: '',
      site: ''
    };
  }

  public getParkingSiteList(): void {
    this.apiProviderParkingService.getProviderList().subscribe({
      next: (res) => {
        if (res && res.data.length > 0) {
          console.log("Providers List : ", res);
          this.parkingSiteList = res;
        }
      },
      error: (err) => {
        console.error('[API Error] Fetching GetProvider List :', err);
      }
    });
  }


  // --- Dropdown Helpers ---
  public toggleDropdown(dropdownId: string, event: Event): void {
    event.stopPropagation();
    this.openDropdown = this.openDropdown === dropdownId ? null : dropdownId;
  }

  public selectOption(field: keyof ProviderParking, value: any): void {
    (this.formData as any)[field] = value;
    this.openDropdown = null;
  }

  public getSelectedLabel(field: keyof ProviderParking): string {
    const value = this.formData[field];
    if (!value) return 'เลือกข้อมูล';

    if (field === 'site') {
      return value.toString();
    }

    // If it's a provider selection (if we add one)
    if (field === 'name' && this.isEditMode) {
      return value.toString();
    }

    return value.toString();
  }

  public onMoreSelect(type: string): void {
    console.log('Opening more details for:', type);
    // Placeholder for advanced selection modal logic
    // Usually this would open another modal with a full list and search/filter
  }

  public closeAllDropdowns(): void {
    this.openDropdown = null;
  }

  public onSave(): void {
    if (!this.validateForm()) return;

    this.isLoading = true;
    const request = this.isEditMode
      ? this.apiProviderParkingService.createProviderParking(this.formData) // Assuming create is used for update or there's an update method
      : this.apiProviderParkingService.createProviderParking(this.formData);

    request.pipe(finalize(() => this.isLoading = false)).subscribe({
      next: (res) => {
        if (res.isSuccess || res.success) {
          this.toast.success(this.isEditMode ? 'แก้ไขข้อมูลผู้ให้บริการสำเร็จ' : 'สร้างผู้ให้บริการสำเร็จ');
          this.saveSuccess.emit();
          this.onClose();
        } else {
          this.toast.error(res.message || 'บันทึกข้อมูลไม่สำเร็จ');
        }
      },
      error: (err) => {
        console.error('[API Error] Save provider failed:', err);
        this.toast.error('เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์');
      }
    });
  }

  public onClose(): void {
    this.close.emit(true);
  }

  private validateForm(): boolean {
    if (!this.formData.name?.trim()) {
      this.toast.error('กรุณากรอกชื่อผู้ให้บริการ');
      return false;
    }
    if (!this.formData.taxId?.trim()) {
      this.toast.error('กรุณากรอกเลขประจำตัวผู้เสียภาษี');
      return false;
    }
    return true;
  }

  // --- Image Handling ---
  public onFileChange(event: any, imageNum: number): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (imageNum === 1) this.image1 = reader.result;
        else this.image2 = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  public triggerFileInput(inputId: string): void {
    document.getElementById(inputId)?.click();
  }
}
